import { Component, OnInit } from '@angular/core';

import { ModalController, NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { User } from './models/users';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { GroupPage } from './pages/group/group.page';
import { Group } from './models/Group';
import { ConfigService } from './services/config.service';
import { UsefulService } from './services/useful.service';
import { RestService } from './services/rest.service';
import { LoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex: any = 0;
  public lstGroups = [];
  public appPages = [
    {
      title: 'Cursos',
      url: '/course',
      icon: 'book-outline'
    },
    {
      title: 'Atividades Extras',
      url: '/download',
      icon: 'cloud-download-outline'
    }
  ];


  // public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  version = '0.0.16';
  vYear = new Date().getFullYear();
  user = new User();

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    private router: Router,
    public auth: AuthService,
    public navController: NavController,
    public modalController: ModalController,

    private loading: LoadingService,
    private rest: RestService,
    public useful: UsefulService,
    public config: ConfigService,

  ) {
    this.initializeApp();
  }

  initializeApp() {
    /*
     this.platform.ready().then(() => {
      
       this.statusBar.styleDefault();
       setTimeout(()=>{
        this.splashScreen.hide();  
      },1000);
     });*/
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
    this.auth.middleware().then((res: boolean) => {
      console.log(res);
      if (res) {
        console.log("res", res);
     
      }
    })

  }

  close() {
    this.storage.clear();
    this.router.navigate(['login']);
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }

    //this.routerNavigation();

  }

  routerNavigation() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
        if (e.url == '/logout' || e.url == '/') {
          this.auth.logout();
        }
        if (e.url != undefined && e.url != null) {
          this.selectedIndex = !e.url.split('/')[1] ? e.url : '/' + e.url.split('/')[1];
        }
      });
  }

  go(url) {
    this.selectedIndex = url;

    if (url == '/logout') {
      this.auth.logout();
      url = '/';
    }

    this.navController.navigateRoot([url], { animated: true, animationDirection: 'forward' });
  }

  /*async selectGroup() {
    const modal = await this.modalController.create({
      component: GroupPage,
    });

    return await modal.present();
  }*/

 
}
